import { cart } from '../../../schema';
import { denormalize } from 'normalizr';

export const selectHydrated = (state) => denormalize('cart', cart, {...state.cart, subjects: state.entities.subjects });


// WEBPACK FOOTER //
// ./src/redux/modules/cart/selectors.js